import dayjs, { Dayjs } from "dayjs"

const ageLimit = dayjs().startOf("day").subtract(16, "years")

export const isDateUnder16YearOld = (date: Dayjs) => {
  return dayjs(date).isAfter(ageLimit)
}

export const isMonthUnder16YearOld = (startOfMonth: Dayjs) => {
  const ageLimit = dayjs().subtract(16, "years")
  return startOfMonth.isAfter(ageLimit)
}

export const isYearUnder16YearOld = (startOfYear: Dayjs) => {
  const ageLimit = dayjs().subtract(16, "years")
  return startOfYear.isAfter(ageLimit)
}
